// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UVvW","fullView":"styles_fullView__3Cfzd"};